module.exports = __webpack_public_path__ + "static/media/-_dashboard.b735bf0c.png";